import React from 'react';
import { Box } from '@mui/material';
import { useDashboardAccess } from '../dashboard/useDashboardAccess';
import { DashSection } from '../dashboard/personal/DashSection';
import MyBreakdownsPanel from './MyBreakdownsPanel';

/**
 * Dashboard section appended to the personal, store, sales, commercial and maintenance boards. Shown only
 * once the institution's module list has resolved and includes maintenance.
 */
const MyBreakdownsDashSection: React.FC = () => {
    const { enabledModules, ready } = useDashboardAccess();
    if (!ready || !enabledModules.has('maintenance')) return null;
    return (
        <Box sx={{ mt: 2 }}>
            <DashSection title="Machine breakdowns" subtitle="Problems you reported" data-help-section="maint.myBreakdowns.panel">
                <MyBreakdownsPanel />
            </DashSection>
        </Box>
    );
};

export default MyBreakdownsDashSection;
